export const totalServices = (servicesLength) => `Total services: ${servicesLength}`;
